module.exports = __webpack_public_path__ + "static/media/transco.f789c2ff.png";